import { reactive, computed } from "vue";

export function usePasswordCheck(email, password, cpassword) {
  // for password to be valid:
  // must be at least 8 characters
  const passwordValidLength = computed(
    () => password.value && password.value.length >= 8,
  );
  // must contain at least one number
  const passwordValidNumber = computed(() => /\d/.test(password.value));
  // must contain at least one uppercase letter
  const passwordValidUppercase = computed(() => /[A-Z]/.test(password.value));
  // must contain at least one lowercase letter
  const passwordValidLowercase = computed(
    () => password.value && /[a-z]/.test(password.value),
  );
  // passwords must match
  const passwordMatch = computed(
    () => password.value && password.value === cpassword.value,
  );
  const passwordValid = computed(
    () =>
      passwordValidLength.value &&
      passwordValidNumber.value &&
      passwordValidUppercase.value &&
      passwordValidLowercase.value,
  );
  const emailValid = computed(() =>
    /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gim.test(email.value),
  );

  const loginFormValid = computed(
    () => emailValid.value && password.value.length > 0,
  );
  const registerFormValid = computed(
    () => emailValid.value && passwordValid.value && passwordMatch.value,
  );

  // make list of password checks
  const passwordChecks = reactive([
    {
      text: "At least 8 characters",
      valid: passwordValidLength,
    },
    {
      text: "At least 1 number",
      valid: passwordValidNumber,
    },
    {
      text: "At least 1 lower case character",
      valid: passwordValidLowercase,
    },
    {
      text: "At least 1 upper case character",
      valid: passwordValidUppercase,
    },
    {
      text: "Passwords must match",
      valid: passwordMatch,
    },
  ]);

  return { loginFormValid, registerFormValid, passwordChecks };
}
